"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var webAApi_2 = require("../../../../api/webAApi");
var moment = require("moment");
var PlayerPromocodesListCtl = /** @class */ (function (_super) {
    __extends(PlayerPromocodesListCtl, _super);
    function PlayerPromocodesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_player_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_id; });
        _this.dk_player_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_login; });
        _this.dk_promo_code_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.promo_code_id; });
        _this.dk_promo_code_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.promo_code_title; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this._errDialog = errDialog;
        return _this;
    }
    PlayerPromocodesListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    PlayerPromocodesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "player promocode with id [" + id + "] not found !";
    };
    PlayerPromocodesListCtl.prototype.LoadData = function (data, onDone) {
        var _this = this;
        webAApi_1.ListPlayerPromocodesByPlayerIdAndDateRangeGet.exec({
            user_player_id: data.playerId,
            from_year: data.from_year,
            from_month: data.from_month,
            from_day: data.from_day,
            from_hour: data.from_hour,
            from_minute: data.from_minute,
            to_year: data.to_year,
            to_month: data.to_month,
            to_day: data.to_day,
            to_hour: data.to_hour,
            to_minute: data.to_minute
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    player_id: resp.list[i].player_id,
                    player_login: resp.list[i].player_login,
                    promo_code_id: resp.list[i].promo_code_id,
                    promo_code_title: resp.list[i].promo_code_title,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PlayerPromocodesListCtl.prototype.ActivatePromoCode = function (data, onDone) {
        var _this = this;
        webAApi_2.DoActivatePromoCode.exec({
            user_player_id: data.user_player_id,
            promo_code: data.promo_code,
            amount: data.amount
        }, function (resp) {
            /* this.DATA.data.push({
 
                 key: resp.activation_log_key_uid,
                 brand_id: resp.brand_id,
                 brand_title: resp.brand_title,
                 player_id: data.user_player_id,
                 player_login: resp.player_login,
                 promo_code_id: resp.promo_code_id,
                 promo_code_title: data.promo_code,
                 date_added: moment(resp.date_added_uts_ms).utc(false)
 
             });*/
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PlayerPromocodesListCtl.prototype.DetailsPromocode = function (data, onDone) {
        var _this = this;
        webAApi_1.DetailsPromoCodeForPlayerGet.exec({
            user_player_id: data.user_player_id,
            promo_code: data.promo_code
        }, function (resp) {
            if (onDone) {
                onDone({
                    is_need_deposit: resp.is_need_deposit,
                    is_can_activate: resp.is_can_activate,
                    bonuses_count: resp.bonuses_count
                });
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return PlayerPromocodesListCtl;
}(BaseController_1.BaseController));
exports.PlayerPromocodesListCtl = PlayerPromocodesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_players_list/ctl/PlayerPromocodesListCtl.ts
// module id = 974
// module chunks = 0